(ns splash.ui.lender-portal.views.pages.login
  (:require
    ["@azure/msal-react" :as msal-react]
    [splash.ui.lender-portal.common.auth :as auth]
    [splash.ui.lender-portal.components.layout :as layout]
    [splash.ui.lender-portal.components.mui :as mui]
    [taoensso.timbre :refer-macros [error]]))

(defn view
  []
  (let [useMsal               (msal-react/useMsal)
        instance              (. useMsal -instance)
        handle-login-redirect (fn []
                                (-> instance
                                  (.loginRedirect (clj->js {:scopes (auth/msal-scopes)
                                                            :prompt "login"}))
                                  (.catch #(error (str %)))))]
    [layout/default
     [mui/grid {:item            true
                :xs              12
                :md              6
                :container       true
                :justify-content "center"
                :align-items     "center"
                :style           {:backgroundColor "#f7f9fc"}}
      [mui/box {:text-align "center"}
       [mui/typography {:variant       "h4"
                        :gutter-bottom true}
        [:img {:src "https://wp.splashfinancial.com/wp-content/uploads/Splash_Logo_Black.svg"
               :alt "Splash"}]]
       [mui/typography {:variant       "subtitle1"
                        :gutter-bottom true} "CONNECT TO:"]
       [mui/typography {:variant       "h6"
                        :gutter-bottom true} "SPLASH FINANCIAL LENDER PORTAL"]
       [mui/button {:onClick handle-login-redirect
                    :variant "contained"
                    :style   {:marginTop "20px"}}
        "LOG IN"]]]
     [mui/grid {:item true
                :xs   12
                :md   6}
      [mui/box {:style {;; TODO: replace this with static asset
                        :background-image    "url(https://s3-alpha-sig.figma.com/img/cf2b/8ac7/12353a04e228083fc9f8dcd98161daa4?Expires=1724630400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=fDI94TcLXzJYDnp6MZbaqdo7wRZ3Y0-goZGbJSyrW3vLDCM1V0iYWiRjb64xgbeBjSRkfhiviai27fqRZgIJttBe9-vpX4xhbFrKK03oZ~0V96W1ekqa4DEd2QvfI-Q-EYXid0NnVKAPy9ynb5qWD1wsCDk9Awcr30Ph0d-K41R0L9cMXxx2AzE4VzDM8k00nW5yUVcXe36JKd8XcFz7v6XhkOBX1kZk9mQRZqyg4IC7o0Rl-ttvn3bh1DlKUZqFrf5KOWMa5gqQusULYlVfDCHl0lsv4pDKxap97ipk5HPx3h~SgSH6O2Mpgqa2-aaRYna6cq0IoYGD~ZQlJ4PnWA__)"
                        :background-size     "cover"
                        :background-position "center"
                        :height              "100%"}}]]]))
